import React from 'react';
import { Outlet } from 'react-router-dom';

import { HeaderComponent } from './header-component';
import { NavigationMenuComponent } from './navigation-menu-component';

export function AppWrapperComponent() {
  return (
    <div className="auth-container">
      <HeaderComponent />
      <div className="auth-content">
        <Outlet />
      </div>
      <div className="app-nav-container">
        <NavigationMenuComponent />
      </div>
    </div>
  );
}
